// Static constants for the redesigned Inventory sidebar panel.
// Ported 1:1 from the Claude Design handoff at
// private/nos-housekeeping-features/project/components-standalone/{tag-selectors,selectors-sidebar}.jsx.

/** Storage-condition tones — colored chips keyed by the canonical
 *  inventory_type_storage_condition.code value (lowercased). */
export const STORAGE_TONES: Record<
  string,
  { bg: string; fg: string; line: string }
> = {
  ambient: { bg: "#e9e7dc", fg: "#4d4733", line: "#d8d2bc" },
  refrigerated: { bg: "#dde7ef", fg: "#2b4f6b", line: "#bdd1e0" },
  refrig: { bg: "#dde7ef", fg: "#2b4f6b", line: "#bdd1e0" },
  frozen: { bg: "#dde4ef", fg: "#283b6b", line: "#bdc7e0" },
  fumehood: { bg: "#f6e8c8", fg: "#7c5813", line: "#e7c97a" },
  flammable: { bg: "#f5d9d2", fg: "#7a2018", line: "#e7b5ad" },
};

/** Seed colors offered to the user when adding a new flavor family. */
export const SEED_COLORS = [
  "#c85a3d", "#b56a9a", "#6ec04a", "#e3a43a", "#d8b46a",
  "#d97b2a", "#7b5a3a", "#c99e4a", "#5a6b3a", "#3a6d8a",
];

/** Document-type metadata — used by DocRow and the missing-docs hint. */
export type DocTypeDef = {
  id: string;
  short: string;
  label: string;
  scope: "lot" | "substance";
};

export const DOC_TYPES: readonly DocTypeDef[] = [
  { id: "coa", short: "CoA", label: "Certificate of Analysis", scope: "lot" },
  { id: "sds", short: "SDS", label: "Safety Data Sheet", scope: "substance" },
  { id: "tds", short: "TDS", label: "Technical Data Sheet", scope: "substance" },
  { id: "spec", short: "Spec", label: "Product specification", scope: "substance" },
  { id: "allergen", short: "Allergen", label: "Allergen statement", scope: "substance" },
];

export const docMeta = (id: string): DocTypeDef =>
  DOC_TYPES.find((d) => d.id === id) ?? DOC_TYPES[0]!;

/** Identifier kinds available to the IdentifierEditor — order matters for
 *  the kind <select>. */
export const IDENTIFIER_KINDS = [
  "CAS", "EC", "FEMA", "PubChem", "ChemSpider", "InChIKey", "Internal",
] as const;
export type IdentifierKindUi = (typeof IDENTIFIER_KINDS)[number];
